import { Box, BoxProps } from '@modusign/design-system';

import { useGNBFoldHandle } from '@app/containers/GlobalNavigationBar/GNBFoldHandleContext';

const FOLDED_GNB_WIDTH = 84;
const GNB_WIDTH = 200;

function ContentContainer(props: BoxProps<'div'>) {
  const { folded } = useGNBFoldHandle();

  return (
    <Box
      display={['block', 'block', 'inline-block']}
      minHeight={['inherit', 'inherit', '100vh']}
      paddingBottom={['60px', '60px', '120px']}
      paddingLeft={[0, 0, folded ? FOLDED_GNB_WIDTH : GNB_WIDTH]}
      paddingTop={['60px', '60px', 0]}
      width="100%"
      {...props}
    />
  );
}

export default ContentContainer;
